import React from "react";
import styles from "../../../pages/dashboard/Dashboard.module.scss";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Loading } from '@onegovbugs/onegov-react-components';
import {
    individualApplicantDetailsItems,
    interStateIndividualDecisionDetailsItems,
    interStateIndividualLicenceDetailsItems,
    attachmentDetailsItems
} from "utils/NavigationHelper";

import { renderSection } from '../../../utils/RenderHelper';
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import {saveImportExportApplication} from "../../../redux/actions";


const IndividualDashboard = props => {

    ScrollToTop();
    RedirectIfCaptchaNotSelected(props);

    const dispatch = useDispatch();
    const formData = useSelector((state) => state.form);
    const { form, formFetching } = formData;

    const personalDetails = useSelector((state) => state.personalDetails);
    const importExportDetails = useSelector(state => state.importExportDetails);
    const interStateDetails = useSelector(state => state.interStateDetails);
    const speciesDetails = useSelector(state => state.speciesDetails);
    const attachmentDetails = useSelector((state) => state.attachmentDetails);
    const disableContinue = (!personalDetails.finished || !importExportDetails.interStateDecisionAppTypeFinished || !speciesDetails.finished || !attachmentDetails.finished);

    let personalDetailsStep = personalDetails.step;
    let attachmentStep = attachmentDetails.step;

    return !formFetching
        ? [
            <div className={"row"}>
                <div className={`col-12`}>
                    <div className={styles.backCont}>
                        <a
                            className={styles.back}
                            onClick={() => {
                                props.history.push(`/import-export/individual-licence-information`);
                            }}
                        >
                            &#x3C;&nbsp;Back
                        </a>
                    </div>
                </div>
                <div className={`col-12`}>
                    <h1 className={`${styles.mainFormTitle} ${styles.underlinedMain}`}>
                        Apply for an Import / Export Licence
                    </h1>
                </div>
            </div>,
            <div className={styles.mainCont}>
                <div className={"row"}>
                    <div className={`col-12`}>
                        <h2>Sections to complete</h2>
                        <p className={styles.mainDescription}>
                            Please use sections of the form below to complete your
                            application. You can complete your application in any order. You
                            can save and exit this form at any time and return to complete
                            it later.
                        </p>
                        {renderSection(
                            "Applicant details",
                            "Use this section to complete the details of the applicant for this licence",
                            `/import-export/applicant-details`,
                            personalDetails.finished,
                            personalDetailsStep,
                            individualApplicantDetailsItems,
                            undefined,
                            props.history,
                            form,
                        )}
                        {renderSection(
                            "Interstate Person/Organisation",
                            "Use this section to complete the details of the Interstate Person/Organisation",
                            `/import-export/individual-interstate-decision`,
                            importExportDetails.interStateDecisionAppTypeFinished,
                            importExportDetails.interStateDecisionAppTypeStep,
                            interStateIndividualDecisionDetailsItems,
                            undefined,
                            props.history,
                            form,
                        )}
                        {renderSection(
                            "Interstate Licence Details",
                            "Use this section to complete the details of the Interstate Licence",
                            `/import-export/interstate-individual-licence`,
                            speciesDetails.finished,
                            speciesDetails.step,
                            interStateIndividualLicenceDetailsItems,
                            undefined,
                            props.history,
                            form,
                        )}
                        {renderSection(
                            "Upload attachments",
                            "Use this section to attach any supporting information required for the selected licence classes",
                            `/import-export/upload-document`,
                            attachmentDetails.finished,
                            attachmentStep,
                            attachmentDetailsItems,
                            undefined,
                            props.history,
                            form
                        )}  
                    </div>
                    <div className={`col-12`}>
                        <Button
                            disabled={disableContinue}
                            onClick={() => {
                                if (!disableContinue) {
                                    props.history.push(`/import-export/review-individual-application`);
                                }
                            }}
                        >
                            Continue
                        </Button>
                        <Button
                            secondary
                            onClick={() => {
                                dispatch(
                                    saveImportExportApplication("", () => {
                                      window.location.href = `${process.env.REACT_APP_BAU_URL}`;
                                    })
                                  );
                            }}
                        >
                            Save & exit application
                        </Button>
                    </div>
                </div>
            </div>,
        ]
        : [
            <div className={"col-12"}>
                <Loading
                    className={styles.loading}
                    label={"Loading..."}
                    type={"ajax"}
                />
            </div>,
        ];

  
};
  
  export default withRouter(props => <IndividualDashboard {...props}/>);
  
